const moduleNameKey = "dashboardCard";

export const dashboardCardEn = {
  [moduleNameKey]: {
    rename: "Modify dashboard",
    duplicate: "Duplicate dashboard",
    delete: "Delete dashboard",
    setDefault: "Set as default",
    namePlaceholder: "Dashboard name",
    descriptionPlaceholder: "Enter your description",
    draft: "Draft",
    published: "Published",
  },
};

export const dashboardCardPtBr = {
  [moduleNameKey]: {
    rename: "Modificar painel",
    duplicate: "Duplicar painel",
    delete: "Excluir painel",
    setDefault: "Definir como padrão",
    namePlaceholder: "Nome do painel",
    descriptionPlaceholder: "Digite sua descrição",
    draft: "Rascunho",
    published: "Publicado",
  },
};

export const dashboardCardDe = {
  [moduleNameKey]: {
    rename: "Dashboard bearbeiten",
    duplicate: "Dashboard duplizieren",
    delete: "Dashboard löschen",
    setDefault: "Als Standard festlegen",
    namePlaceholder: "Dashboard-Name",
    descriptionPlaceholder: "Beschreibung eingeben",
    draft: "Entwurf",
    published: "Veröffentlicht",
  },
};

export const dashboardCardZhHans = {
  [moduleNameKey]: {
    rename: "修改仪表板",
    duplicate: "复制仪表板",
    delete: "删除仪表板",
    setDefault: "设为默认",
    namePlaceholder: "仪表板名称",
    descriptionPlaceholder: "输入描述",
    draft: "草稿",
    published: "已发布",
  },
};

export const dashboardCardIt = {
  [moduleNameKey]: {
    rename: "Modifica dashboard",
    duplicate: "Duplica dashboard",
    delete: "Elimina dashboard",
    setDefault: "Imposta come predefinito",
    namePlaceholder: "Nome dashboard",
    descriptionPlaceholder: "Inserisci una descrizione",
    draft: "Bozza",
    published: "Pubblicato",
  },
};

export const dashboardCardEs = {
  [moduleNameKey]: {
    rename: "Modificar panel",
    duplicate: "Duplicar panel",
    delete: "Eliminar panel",
    setDefault: "Establecer como predeterminado",
    namePlaceholder: "Nombre del panel",
    descriptionPlaceholder: "Introduce tu descripción",
    draft: "Borrador",
    published: "Publicado",
  },
};

export const dashboardCardNl = {
  [moduleNameKey]: {
    rename: "Dashboard aanpassen",
    duplicate: "Dashboard dupliceren",
    delete: "Dashboard verwijderen",
    setDefault: "Als standaard instellen",
    namePlaceholder: "Naam van dashboard",
    descriptionPlaceholder: "Voer je beschrijving in",
    draft: "Concept",
    published: "Gepubliceerd",
  },
};

export const dashboardCardTr = {
  [moduleNameKey]: {
    delete: "Gösterge tablosunu sil",
    descriptionPlaceholder: "Açıklamanızı girin",
    draft: "Taslak",
    duplicate: "Yinelenen kontrol paneli",
    namePlaceholder: "Kontrol paneli adı",
    published: "Yayınlandı",
    rename: "Kontrol panelini değiştir",
    setDefault: "Varsayılan olarak ayarla",
  },
};
